<template>
  <Modal
    v-model="_value"
    width="500"
    title="BSJ设置限速报警"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <Form :model="reqParams" :label-width="80">
      <FormItem prop="maxSpeed" label="限速阀值(单位:km/h)">
        <Input v-model="reqParams.maxSpeed" placeholder="请输入限速阀值">
        </Input>
      </FormItem>
      <FormItem prop="holdTime" label="持续时间(单位:s)">
        <Input v-model="reqParams.holdTime" placeholder="请输入持续时间">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

  export default {
    name: 'bsjsetmaxspeedmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        reqParams: {
          maxSpeed:150,
          holdTime:10
        }
      }
    },
    methods: {
      ...mapActions([
      ]),
      onOk() {
        let content = null
        if (this.reqParams.maxSpeed<100){
          content ='<SPBSJ*P:BSJGPS*p:bsjkj*s:' + 0 + this.reqParams.maxSpeed.toString(10) + this.reqParams.holdTime.toString(10) + '>'
        } else{
          content ='<SPBSJ*P:BSJGPS*p:bsjkj*s:' + this.reqParams.maxSpeed.toString(10) + this.reqParams.holdTime.toString(10) + '>'
        }

        store.dispatch('NetCommandServ_SendCommand', {
          params: { id: this._initValue, content: content, urgent: true }
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.reqParams.maxSpeed = 120
          this.reqParams.holdTime = 10
        }
      },
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
